import React from "react";

const Game = (props) => {
  console.log("Game props", props);

  if (!props.data?.topScores || props.data.topScores.length === 0) {
    return null;
  }

  return (
    <div className="bg-[#181f52] text-white rounded-xl p-6 w-full max-w-6xl mx-auto font-sans">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="flex flex-col items-center gap-6">
          <div className="text-2xl text-white text-center Kallisto_Bold">
            TOP FRIEND SCORE
          </div>
          <div className="w-full max-w-xs flex items-center justify-between bg-white text-[#0a0e2c] rounded px-6 py-3 font-bold text-lg">
            <span>🏆</span>
            <span className="Kallisto_Bold">{props.data.allTime.name}</span>
            <span className="text-2xl Kallisto_Bold">
              {props.data.allTime.score}
            </span>
          </div>

          {/* <div className="text-2xl text-white text-center Kallisto_Bold">
            PERSONAL BEST
          </div>
          <div className="w-full max-w-xs flex items-center justify-between bg-white text-[#0a0e2c] rounded px-6 py-3 font-bold text-lg">
            <span>🏆</span>
            <span className="Kallisto_Bold">{props.data.topOfMonth.name}</span>
            <span className="text-2xl Kallisto_Bold">
              {props.data.topOfMonth.score}
            </span>
          </div> */}

          <img
            className="mx-auto mt-6 w-[50%]"
            src={props.data.game.icon}
            alt="Run of Play"
          />
        </div>

        <div className="flex flex-col justify-start">
          <div className="text-2xl text-white text-center Kallisto_Bold mb-6">
            ALL TIME TOP SCORES
          </div>

          <div className="space-y-2">
            {props.data.topScores.map((player, index) => (
              <div
                key={index}
                className="flex justify-between items-center bg-[#181f52] px-4 rounded-lg Kallisto_Bold"
              >
                <div className="text-2xl text-white">{index + 1}ᵗʰ</div>
                <div className="text-white">{player.name}</div>
                <div className="text-white text-2xl">
                  {player.score}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Game;
